import { observer } from 'mobx-react';
import { Input } from '@monorepo/base/src/components/form/input/input';
import { BidderCampaignTargetingLinkCidModel } from '../../../../models/bidder-campaign/bidder-campaign-targeting-link.model';
import styles from './bidder-targeting-links-table.module.scss';

export const TargetingLinkCid = observer(({ cid }: { cid: BidderCampaignTargetingLinkCidModel }) => {
	return (
		<div className={styles.cidRow}>
			<Input
				className={styles.cidInput}
				value={`${cid.cid}`}
				onValue={value => {
					cid.cid = parseInt(value) || 0;
				}}
			/>
			<Input
				className={styles.cidInput}
				value={`${cid.weight}`}
				onValue={value => {
					cid.weight = parseInt(value) || 0;
				}}
			/>
		</div>
	);
});
